// extracted by mini-css-extract-plugin
export default {"guessContainer":"Guess_guessContainer__InMXO","guess":"Guess_guess__VIqPo","loading":"Guess_loading__xFHPm","mobile":"Guess_mobile__HQM5V"};